<template>
  <article>
    <MastheadAlt
      subtitle="Link in bio for Small Business"
      title="Drive traffic to your most important places"
      text="Create an on brand landing page for all of your links across the web. Highly optimized for mobile and conversions."
      ctaText="(10-day trial included with every paid plan)"
      :profile-images="[
        '/campsites/small-business/campsite-electrameccanica.png',
        '/campsites/small-business/campsite-hometap.png',
        '/campsites/small-business/campsite-justinboots.png',
        '/campsites/small-business/campsite-lightburn.png',
        '/campsites/small-business/campsite-seeitalytravel.png',
        '/campsites/small-business/campsite-socialburro.png',
        '/campsites/small-business/campsite-telluridenews.png',
        '/campsites/small-business/campsite-topotoppers.png',
        '/campsites/small-business/campsite-friendlypinescamp.png',
        '/campsites/small-business/campsite-dharamsala.png',
        '/campsites/small-business/campsite-smallstudio.png',
        '/campsites/small-business/campsite-wecrushmarketing.png',
        '/campsites/small-business/campsite-lunasconsulting.png',
      ]"
    >
      <Button href="https://app.campsite.bio/create-account" size="large"
        >Get started</Button
      >
    </MastheadAlt>

    <SeenOn />

    <!-- <TestimonialSection
      title="Campsite.bio has helped my business and my audience grow"
      img-src="/campsites/small-business/campsite-smallstudio.png"
      name="Ashton Henry"
    >
      <p>
        Having a professional link in bio page is really important to my
        business since most of my traffic comes from different social channels
        like Instagram, Twitter, and LinkedIn - Campsite's features have helped
        me look professional and their embed features have increased my email
        opt-ins, product sales, and YouTube and podcast downloads.
      </p>
      <p>
        I can't recommend Campsite enough if you're looking for a professional
        link in bio to grow your business.
      </p>
    </TestimonialSection> -->

    <LargeTextSection
      >As a small business your time is valuable. Stop worrying about what link
      you should share on social media and instead create an optimized, super
      fast landing page that always has the most important links for your
      business.</LargeTextSection
    >

    <FeatureSection
      title="Create an on brand bio link that is optimized for mobile and conversions"
    >
      <VText slot="text">
        Campsite.bio takes the work and worries out of having a page with all of
        your most important links on it to share with your audience across
        social media.
      </VText>

      <FeatureCard
        span="2"
        title="Customization features"
        bg-color="secondary"
        color="secondary"
      >
        <VisibilityIcon slot="icon" />
        <VText>
          You shouldn't have to compromise on how your brand looks on your bio
          link. Campsite.bio offers dozens of options so you can create a
          seamless experience between your social channels, your bio link and
          your website.
        </VText>
        <img
          slot="img"
          src="~/assets/images/use-cases/creators/appearance-page.png"
          loading="lazy"
          alt="Appearance page"
        />
      </FeatureCard>
      <FeatureCard title="Optimized for mobile">
        <SvgIcon slot="icon" viewBox="0 0 24 24">
          <path
            d="M12,16A3,3 0 0,1 9,13C9,11.88 9.61,10.9 10.5,10.39L20.21,4.77L14.68,14.35C14.18,15.33 13.17,16 12,16M12,3C13.81,3 15.5,3.5 16.97,4.32L14.87,5.53C14,5.19 13,5 12,5A8,8 0 0,0 4,13C4,15.21 4.89,17.21 6.34,18.65H6.35C6.74,19.04 6.74,19.67 6.35,20.06C5.96,20.45 5.32,20.45 4.93,20.07V20.07C3.12,18.26 2,15.76 2,13A10,10 0 0,1 12,3M22,13C22,15.76 20.88,18.26 19.07,20.07V20.07C18.68,20.45 18.05,20.45 17.66,20.06C17.27,19.67 17.27,19.04 17.66,18.65V18.65C19.11,17.2 20,15.21 20,13C20,12 19.81,11 19.46,10.1L20.67,8C21.5,9.5 22,11.18 22,13Z"
          />
        </SvgIcon>
        <VText>
          Speed matters on the web. Campsite.bio offers you a highly optimized
          landing page that converts for your social audience.
        </VText>
      </FeatureCard>
      <FeatureCard title="Link types">
        <GridIcon slot="icon" />
        <VText
          >Use our suite of link types to power your link in bio. Video and
          music embeds, carousels, an image grid, and more.
        </VText>
      </FeatureCard>
    </FeatureSection>

    <FeatureSection
      title="Keep your content fresh with Campsite Pro automation features"
      bg-color="gray100"
    >
      <VText slot="text">
        Hook up our automated link types to keep your profile content fresh,
        automatically.
      </VText>
      <Button slot="cta" to="/pricing">Compare features</Button>

      <FeatureCard title="Automation">
        <RefreshIcon slot="icon" />
        <VText
          >Keep your profile fresh with our automated link types, like the feed
          and image grid. They'll pull in the newest content from Youtube, a
          blog, or Instagram, automatically.
        </VText>
      </FeatureCard>
      <FeatureCard title="Custom domain">
        <WebsiteIcon slot="icon" />
        <VText>
          You already have a domain, why not use it for you bio link? Integrate
          your domain right into your profile (ex. links.mydomain.com).
        </VText>
      </FeatureCard>
      <FeatureCard title="Premium link types">
        <GridIcon slot="icon" />
        <VText
          >Unlock our best link types with multiple carousels, opt-in forms,
          feed links, forms (Typeform and Jotform), image grids and so much
          more.</VText
        >
      </FeatureCard>
      <FeatureCard title="Scheduling links">
        <EventIcon slot="icon" />
        <VText
          >Do you have timed promotions or events? Put up and take down your
          links at specific times with our scheduling features.
        </VText>
      </FeatureCard>
      <FeatureCard title="Highlight a link">
        <StarIcon slot="icon" />
        <VText
          >Draw attention to your most important link with a highlight
          animation.
        </VText>
      </FeatureCard>
      <FeatureCard title="Multiple profiles">
        <AccountMultipleIcon slot="icon" />
        <VText
          >Leverage multiple profiles out of the box to create unique ones for
          each of your social accounts. Three profiles are included out of the
          box on Pro.
        </VText>
      </FeatureCard>
    </FeatureSection>

    <RaisedCtaSection
      title="Simplify your link in bio management today"
      text="An easy to use tool to help you focus on what is important."
    >
      <Button href="https://app.campsite.bio/create-account" size="large"
        >Get started</Button
      >
    </RaisedCtaSection>
  </article>
</template>

<script>
import {
  VText,
  Button,
  VisibilityIcon,
  AccountMultipleIcon,
  WebsiteIcon,
  GridIcon,
  RefreshIcon,
  EventIcon,
  StarIcon,
  SvgIcon,
} from '@campsite-bio/component-lib';

import SeenOn from '@/components/seen-on-analytics';
import TestimonialSection from '@/components/testimonials/testimonial-section';
import FeatureCard from '@/components/features/feature-card';
import FeatureSection from '@/components/features/feature-section';
import RaisedCtaSection from '@/components/sections/raised-cta-section';
import LargeTextSection from '@/components/sections/large-text-section';
import MastheadAlt from '@/components/sections/masthead-alt';
import { generateMeta } from '~/utils/generate-meta';

export default {
  components: {
    VText,
    Button,
    SeenOn,
    TestimonialSection,
    FeatureCard,
    FeatureSection,
    VisibilityIcon,
    AccountMultipleIcon,
    WebsiteIcon,
    GridIcon,
    RefreshIcon,
    EventIcon,
    RaisedCtaSection,
    LargeTextSection,
    MastheadAlt,
    StarIcon,
    SvgIcon,
  },

  head() {
    return generateMeta({
      title: 'Link in bio for Small Business - Campsite.bio',
      description:
        'Drive traffic to your most important places. Learn more about the features Campsite.bio offers to small businesses.',
    });
  },
};
</script>

<style lang="scss" scoped></style>
